<template>
  <div class="employee-hr-timeline">
    <h6 class="timeline-title"><i class="mdi mdi-timeline"></i> HR history timeline</h6>
    <div v-if="loading" class="text-muted">Loading...</div>
    <div v-else-if="!actions.length" class="text-muted">No HR actions recorded.</div>
    <div v-else class="timeline-list">
      <div v-for="item in actions" :key="item.id" class="timeline-item">
        <div class="timeline-marker" :class="getActionClass(item.action_type)"></div>
        <div class="timeline-content">
          <strong>{{ item.action_type }}</strong> – {{ item.action_date }}
          <div v-if="item.description" class="timeline-desc">{{ item.description }}</div>
          <div class="timeline-meta">Issued by: {{ item.issued_by || '–' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { execute, authUrl } from "@/api";

export default {
  name: "EmployeeHrTimeline",
  props: {
    employeeId: { type: [Number, String], default: null }
  },
  data() {
    return {
      actions: [],
      loading: false
    };
  },
  watch: {
    employeeId: {
      immediate: true,
      handler(id) {
        if (id) this.load();
        else this.actions = [];
      }
    }
  },
  methods: {
    load() {
      if (!this.employeeId) return;
      this.loading = true;
      const fd = new FormData();
      fd.append("function", "getEmployeeHrActions");
      fd.append("employeeId", this.employeeId);
      execute(fd, authUrl)
        .then((res) => {
          this.actions = (res.data && res.data.success && res.data.data && res.data.data.actions) ? res.data.data.actions : [];
        })
        .catch(() => { this.actions = []; })
        .finally(() => { this.loading = false; });
    },
    getActionClass(type) {
      const t = (type || "").toLowerCase();
      if (t.includes("warning") || t.includes("show cause") || t.includes("suspension") || t.includes("interdiction") || t.includes("termination")) return "action-disciplinary";
      if (t.includes("commendation") || t.includes("promotion") || t.includes("transfer")) return "action-positive";
      return "action-neutral";
    }
  }
};
</script>

<style scoped>
.employee-hr-timeline { margin-top: 16px; padding: 12px; background: #f8f9fa; border-radius: 8px; }
.timeline-title { margin-bottom: 12px; font-size: 14px; }
.timeline-list { padding-left: 20px; border-left: 2px solid #dee2e6; }
.timeline-item { position: relative; margin-bottom: 12px; }
.timeline-item .timeline-marker { position: absolute; left: -26px; top: 4px; width: 10px; height: 10px; border-radius: 50%; }
.timeline-item .timeline-marker.action-disciplinary { background: #dc3545; }
.timeline-item .timeline-marker.action-positive { background: #28a745; }
.timeline-item .timeline-marker.action-neutral { background: #6c757d; }
.timeline-content { font-size: 13px; }
.timeline-desc { margin-top: 4px; color: #495057; }
.timeline-meta { font-size: 11px; color: #6c757d; margin-top: 2px; }
.text-muted { color: #6c757d; font-size: 13px; }
</style>
